import { useRouter } from "next/router";
import { useCallback } from "react";

/**
 * Hook for redirecting to a given path on the client-side.
 * Allows us to pass `asWindow` to redirect using `window.location.href`
 * which is useful for making a full server request instead of a NextJS
 * client-side route change.
 */
export default function useRedirect() {
  const router = useRouter();
  const redirect = useCallback(
    (
      to: string,
      opts?: { asWindow?: boolean; asIframe?: boolean; asNewTab?: boolean }
    ) => {
      // Prevent on SSR
      if (typeof window === "undefined") {
        return;
      }

      // set asIframe to true when the page is used in an iframe and you want to redirect the parent page
      if (opts?.asIframe && window.top) {
        window.top.location.href = to;
      }

      // set asWindow to true when you dont want to use nextjs router. i.e. when you want to go from nextjs to the web-app.
      if (opts?.asWindow) {
        window.location.href = to;

        return;
      }
      if (opts?.asNewTab) {
        window.open(to, "_blank");
        return;
      }

      if (router.isReady) {
        router.push(to);
      }
    },
    [router]
  );

  return { redirect };
}
